export const formatPrice = (price: number | null | undefined) => {
  if (price === undefined || price === null) return '';
  let formattedPrice = price.toFixed(2).replace('.', ',');
  if (price >= 1000) {
    formattedPrice = formattedPrice.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  }
  return formattedPrice.replace(',00', '');
};
